import React from 'react';
import type { CoreEnv } from '@eventbrite/legacy-infra.context-types';
import { TopDestinations } from '@/types';
import { TLD_UNITED_STATES } from '@/shared/constants/constants';
import { TOP_DESTINATIONS_US_EXPANDED } from '@/shared/constants/topDestinations';
import { TopDestinationsContainer } from '../TopDestinations';
import { ThingsToDoShelfContainer } from '../ThingsToDoShelfContainer';
import styles from './HomeBottomShelfContainer.module.scss';
import { PopularCitiesContainer } from '../PopularCitiesContainer';
import { StatesContainer } from '../StatesContainer';
export interface HomeBottomShelfContainerProps {
    ebDomain: string;
    languageSubdirectory: string;
    topDestinations?: TopDestinations;
    tld: string;
    localeInfo: CoreEnv['localeInfo'];
    /**
     * When on (and US/.com), expands "Top destinations" to the GTF top 30 and
     * renders the "by state" module. Resolved server-side so logged-out /
     * Googlebot requests see the modules. Off => today's homepage.
     */
    geoSeoLinksEnabled: boolean;
}

export const HomeBottomShelfContainer: React.FunctionComponent<HomeBottomShelfContainerProps> = (
    props,
) => {
    const { ebDomain, topDestinations, languageSubdirectory, tld, localeInfo, geoSeoLinksEnabled } =
        props;

    // US (.com) only: the geo SEO internal-linking modules never render elsewhere.
    const isUsGeoSeo = geoSeoLinksEnabled && tld === TLD_UNITED_STATES;

    const resolvedTopDestinations = isUsGeoSeo ? TOP_DESTINATIONS_US_EXPANDED : topDestinations;
    // Suppress the expanded city cards from the popular-cities pills so no city
    // appears in both modules.
    const additionalExcludedSlugs = isUsGeoSeo
        ? TOP_DESTINATIONS_US_EXPANDED.map((destination) => destination.location_slug)
        : undefined;

    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>
                <TopDestinationsContainer
                    ebDomain={ebDomain}
                    languageSubdirectory={languageSubdirectory}
                    topDestinations={resolvedTopDestinations}
                    tld={tld}
                />
                <PopularCitiesContainer
                    languageSubdirectory={languageSubdirectory}
                    tld={tld}
                    localeInfo={localeInfo}
                    additionalExcludedSlugs={additionalExcludedSlugs}
                />
                {isUsGeoSeo && <StatesContainer languageSubdirectory={languageSubdirectory} />}
                <ThingsToDoShelfContainer languageSubdirectory={languageSubdirectory} />
            </div>
        </div>
    );
};
